<!--  抽卡结果-->
<template>
  <div class="drawCard" v-show="show">
    <div class="box">
      <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/lottery.gif" alt="">
      <div class="close" @click="changeShow"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  props:{
  },
  computed: {},
  watch: {},
  methods: {
    changeShow() {
      this.show = !this.show;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.drawCard {
  position: fixed;
  top: 0;
  left: 0;
   z-index: 10;
  width: 100%;
  height: 100%;
  padding: 248px 115px 0 115px;
  background: rgba($color: #000, $alpha: 0.8);
  .box {
   width: 520px;
   height: 690px;
    img{
      width: 100%;
    }
    .close {
      width: 66px;
      height: 66px;
      margin: 0 auto;
      background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/close.png');
      background-size: 100%;
    }
  }
}
  @keyframes flip {
    0% {
      transform: perspective(1000px) rotateY(0deg);
    }
     33% {
      transform: perspective(1000px) rotateY(30deg);
    }
     66% {
      transform: perspective(1000px) rotateY(-30deg);
    }
     100% {
      transform: perspective(1000px) rotateY(0deg);
    }

  }
</style>
